import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Facebook, Twitter } from "lucide-react";

const RAFHA_LOGO = "https://customer-assets.emergentagent.com/job_4c248649-c7ad-49ab-8962-bf67e4ed6b65/artifacts/rogqq55c_F1371478-432E-404F-80CC-D2C1450E0839.png";

const Footer = () => {
  return (
    <footer className="bg-charcoal border-t border-white/5">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-4 mb-6">
              <div className="relative">
                <div className="absolute inset-0 bg-gold/15 rounded-full blur-lg"></div>
                <img 
                  src={RAFHA_LOGO} 
                  alt="Rafha Entertainment" 
                  className="w-16 h-16 object-contain relative z-10 drop-shadow-[0_0_10px_rgba(212,175,55,0.3)]" 
                />
              </div>
              <div>
                <span className="font-heading font-bold text-white text-xl block">Rafha Entertainment</span>
                <span className="text-white/40 text-sm">Your Event. Our Talent.</span>
              </div>
            </Link>
            <p className="text-white/60 mb-6 max-w-md">
              Connecting clients with trusted, vetted event professionals. 
              Book DJs, musicians, photographers, caterers, and more—all in one place.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/60 hover:bg-gold/10 hover:text-gold transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/60 hover:bg-gold/10 hover:text-gold transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/60 hover:bg-gold/10 hover:text-gold transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { href: "/vendors", label: "Browse Vendors" },
                { href: "/choice-mobile", label: "Choice Mobile" },
                { href: "/auth", label: "Sign In" },
                { href: "/auth", label: "Register" },
              ].map((link) => (
                <li key={link.href + link.label}>
                  <Link 
                    to={link.href}
                    className="text-white/60 hover:text-gold transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-white mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-white/60 text-sm">
                <Phone className="w-4 h-4 text-gold" />
                (877) 295-5905
              </li>
              <li className="flex items-center gap-3 text-white/60 text-sm">
                <Mail className="w-4 h-4 text-gold" />
                info@rafhaentertainment.com
              </li>
              <li className="flex items-start gap-3 text-white/60 text-sm">
                <MapPin className="w-4 h-4 text-gold shrink-0 mt-0.5" />
                Montgomery, AL & Surrounding Areas
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Rafha Entertainment. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-white/40 hover:text-white text-sm">Privacy Policy</a>
            <a href="#" className="text-white/40 hover:text-white text-sm">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
